// extracted by mini-css-extract-plugin
module.exports = {"button":"feedback_box_button-module__button--sBNfk"};